(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tutte-discount-teaser"]) return;
  try {
    
  (() => {
    const root = document.querySelector('[data-tutte-welcome]');
    if (!root || root.dataset.initialized === 'true') return;
    root.dataset.initialized = 'true';

    const dialog = root.querySelector('[data-tutte-welcome-dialog]');
    const openButton = root.querySelector('[data-tutte-welcome-open]');
    const closeButtons = root.querySelectorAll('[data-tutte-welcome-close]');
    const copyButton = root.querySelector('[data-tutte-welcome-copy]');
    const code = root.querySelector('[data-tutte-welcome-code]');

    // Keep a real gap above the rating, including its configured mobile offset.
    const rating = document.querySelector('.tutte-google-rating');
    const positionCoupon = () => {
      if (!openButton) return;
      if (!rating?.isConnected || !rating.getClientRects().length) {
        openButton.style.removeProperty('--tutte-coupon-bottom');
        return;
      }
      const ratingBottom = parseFloat(window.getComputedStyle(rating).bottom) || 0;
      openButton.style.setProperty('--tutte-coupon-bottom', `${Math.ceil(ratingBottom + rating.getBoundingClientRect().height + 20)}px`);
    };
    positionCoupon();
    window.addEventListener('resize', positionCoupon, { passive: true });
    window.visualViewport?.addEventListener('resize', positionCoupon, { passive: true });
    if (rating && 'ResizeObserver' in window) {
      const ratingObserver = new ResizeObserver(positionCoupon);
      ratingObserver.observe(rating);
    }
    if (rating) {
      new MutationObserver(positionCoupon).observe(rating, { attributes: true, attributeFilter: ['style', 'class'] });
    }

    const openDialog = () => {
      if (!dialog.open) dialog.showModal();
    };

    const closeDialog = () => {
      if (dialog.open) dialog.close();
    };

    openButton?.addEventListener('click', openDialog);
    closeButtons.forEach((button) => button.addEventListener('click', closeDialog));

    dialog?.addEventListener('click', (event) => {
      if (event.target === dialog) closeDialog();
    });

    copyButton?.addEventListener('click', async () => {
      if (!code) return;
      try {
        await navigator.clipboard.writeText(code.textContent.trim());
        copyButton.textContent = copyButton.dataset.copiedLabel;
        window.setTimeout(() => {
          copyButton.textContent = copyButton.dataset.copyLabel;
        }, 2200);
      } catch (error) {
        const selection = window.getSelection();
        const range = document.createRange();
        range.selectNodeContents(code);
        selection.removeAllRanges();
        selection.addRange(range);
      }
    });

    if (root.querySelector('[data-tutte-welcome-copy]')) openDialog();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tutte-google-rating"] && !Shopify.designMode) return;
  try {
    
  function initializeTutteRatings() {
    document.querySelectorAll('.tutte-google-rating').forEach(function(badge) {
      if (badge.dataset.tutteInitialized) return;
      badge.dataset.tutteInitialized = 'true';
      function minimize() {
        if (!badge.isConnected) return;
        if (badge.contains(document.activeElement)) {
          badge.addEventListener('focusout', function() {
            setTimeout(minimize, 0);
          }, { once: true });
          return;
        }
        badge.classList.add('is-minimized');
      }
      setTimeout(minimize, 5000);
    });
  }

  function closeTutteGoogleDialog(dialog) {
    if (!dialog) return;
    dialog.hidden = true;
    document.body.classList.remove('tutte-google-dialog-open');
    var badge = document.querySelector('[aria-controls="' + dialog.id + '"]');
    if (badge) {
      badge.setAttribute('aria-expanded', 'false');
      badge.focus();
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeTutteRatings, { once: true });
  } else {
    initializeTutteRatings();
  }

  document.addEventListener('shopify:section:load', initializeTutteRatings);

  document.addEventListener('click', function(event) {
    var opener = event.target.closest('[data-tutte-rating-open]');
    if (opener) {
      var dialog = document.getElementById(opener.getAttribute('aria-controls'));
      if (dialog) {
        dialog.hidden = false;
        opener.setAttribute('aria-expanded', 'true');
        document.body.classList.add('tutte-google-dialog-open');
        var closeButton = dialog.querySelector('[data-tutte-rating-close]');
        if (closeButton) closeButton.focus();
      }
      return;
    }

    var close = event.target.closest('[data-tutte-rating-close]');
    if (close) {
      closeTutteGoogleDialog(close.closest('[data-tutte-rating-dialog]'));
      return;
    }

    var dismiss = event.target.closest('[data-tutte-rating-dismiss]');
    if (dismiss) dismiss.closest('.tutte-google-rating').remove();
  });

  document.addEventListener('keydown', function(event) {
    if (event.key !== 'Escape') return;
    var dialog = document.querySelector('[data-tutte-rating-dialog]:not([hidden])');
    closeTutteGoogleDialog(dialog);
  });

  } catch(e) { console.error(e); }
})();
})();
